<template>
    <div class="questions-form">
        <div>
            <h2 class="questions-form__title">
                {{ result.mess.questionsFormTitle }}
            </h2>
            <p class="questions-form__text">
              {{ result.mess.questionsFormText }} 👋
            </p>
        </div>
        <form class="questions-form-block" @submit.prevent="handlerSubmit">
            <DefInput name="name" :label="result.mess.inputName" :placeholder="result.mess.placeholderName" required />
            <DefEmail name="email" :label="result.mess.inputEmail" :placeholder="result.mess.placeholderEmail" required />
            <DefTextarea name="text" :label="result.mess.inputText" :placeholder="result.mess.placeholderText" />
            <DefButtonPrimary type="submit">
              {{ result.mess.askQuestions }}
            </DefButtonPrimary>
        </form>
    </div>
</template>

<script>
import DefInput from "vueComponents/Def/DefInput/DefInput";
import DefEmail from "vueComponents/Def/DefEmail/DefEmail";
import DefTextarea from "vueComponents/Def/DefTextarea/DefTextarea";
import DefButtonPrimary from "vueComponents/Def/DefButton/DefButtonPrimary";

export default {
    name: 'QuestionsForm',
    props: ['result'],
    components: {
        DefInput,
        DefEmail,
        DefTextarea,
        DefButtonPrimary,
    },
    mounted() {
    },
    methods: {
        handlerSubmit({ target }) {
            const formData = new FormData(target);
            formData.append("handler", "questions");
            formData.append("func", "addQuestion");
          axios.post('/ajax/common.php', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function (response) {
            if (response.data.status == 'ok'){
              window.location.reload();
            }
          });
        }
    }
}
</script>

<style lang="scss" scoped>
.questions-form{
    display: grid;
    grid-row-gap: 42px;
    @include point-lg{
        grid-template-columns: 282px 1fr;
        grid-column-gap: 126px;
        //margin-bottom: 118px;
    }
    &__title{
        color: var(--abv-black-2, #333);
        font-size: 30px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin-bottom: 20px;
        @include point-md{
            font-size: 36px;
            margin-bottom: 9px;
        }
        @include point-lg{
            font-size: 30px;
            line-height: 30px;
            margin-bottom: 36px;
        }
    }
    &__text{
        color: var(--abv-black-2, #333);
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        @include point-lg{
            font-size: 22px;
        }
    }
}
.questions-form-block{
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-gap: 24px;
    ::v-deep{
        .def-input-component{
            grid-column-start: 1;
            grid-column-end: 2;
        }
        .def-email{
            grid-column-start: 2;
            grid-column-end: 3;
        }
        .def-textarea{
            grid-column-start: 1;
            grid-column-end: 3;
        }
        .def-button-primary{
            grid-column-start: 1;
            grid-column-end: 3;
        }
    }
}
</style>